<template>
  <component
    :is="clickable ? 'Button' : 'span'"
    v-tooltip.bottom="tooltip"
    :class="computedClasses"
    :disabled="clickable ? disabled : undefined"
    :icon="clickable ? `${icon}` : undefined"
    :severity="severity"
    text
  >
    <i
      v-if="isPrimeIcon"
      :class="icon"
    ></i>
    <IconifyIcon
      v-else
      :icon="icon"
      class="iconify"
    />
  </component>
</template>

<script>
  import Button from 'primevue/button';
  import useComponentConfig from '@/composables/useComponentConfig';
  import { Icon as IconifyIcon } from '@iconify/vue';

  const componentConfig = useComponentConfig();
  export default {
    name: 'Icon',
    props: {
      size: {
        type: String,
        default: componentConfig.sizes.BASE
      },
      color: {
        type: String,
        default: componentConfig.colors.GRAY
      },
      tooltip: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        required: true
      },
      clickable: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      severity: {
        type: String
      }
    },

    components: {
      Button,
      IconifyIcon
    },

    computed: {
      canClick() {
        return this.clickable && !this.disabled;
      },
      isPrimeIcon() {
        return this.icon.startsWith('pi');
      },
      computedClasses() {
        return [this.sizeStyle, this.colorStyle, { 'cursor-pointer': this.canClick }, { 'opacity-50': this.disabled }, 'inline-flex items-center justify-center'];
      },
      sizeStyle() {
        return {
          [componentConfig.sizes.XS]: 'text-xs',
          [componentConfig.sizes.SM]: 'text-sm',
          [componentConfig.sizes.BASE]: 'text-base',
          [componentConfig.sizes.LG]: 'w-5 h-5',
          [componentConfig.sizes.XL]: 'text-xl',
          [componentConfig.sizes.TWO_XL]: 'text-2xl',
          [componentConfig.sizes.THREE_XL]: 'text-3xl',
          [componentConfig.sizes.FOUR_XL]: 'text-4xl',
          [componentConfig.sizes.FIVE_XL]: 'text-5xl',
          [componentConfig.sizes.SIX_XL]: 'text-6xl',
          [componentConfig.sizes.SEVEN_XL]: 'text-7xl',
          [componentConfig.sizes.EIGHT_XL]: 'text-8xl',
          [componentConfig.sizes.NINE_XL]: 'text-9xl'
        }[this.size];
      },
      colorStyle() {
        return {
          [componentConfig.colors.BLUE]: `text-blue-700 ${this.canClick ? 'hover:text-blue-600' : ''}`,
          [componentConfig.colors.GRAY]: `text-gray-500 ${this.canClick ? 'hover:text-gray-400' : ''} dark:text-gray-300`,
          [componentConfig.colors.RED]: `text-red-500 ${this.canClick ? 'hover:text-red-400' : ''}`,
          [componentConfig.colors.WHITE]: 'text-white',
          [componentConfig.colors.YELLOW]: 'text-yellow-500 hover:text-yellow-400'
        }[this.color];
      }
    }
  };
</script>
